import { get } from 'lodash'
import { cloneElement, createElement } from 'react'
import useTable from './useTable'
import { getCellKey } from './utils'

const DefaultRow = props => <tr {...props} />

const Row = ({ rowData, index }) => {
	const {
		columns,
		options: { rowKey, onRowClick, rowComponent: CustomRow },
		state,
		setState,
	} = useTable()

	const TheRow = CustomRow || DefaultRow
	// A click on a control inside the row (link, button, input, …) is that control's,
	// not the row's — otherwise the invoice PO input or a photo download would navigate.
	const handleClick = event => {
		if (!onRowClick) return
		const control = event.target.closest && event.target.closest('a, button, input, select, textarea, label, [role="button"]')
		if (control && control !== event.currentTarget) return
		onRowClick(rowData)
	}
	return (
		<TheRow
			role={onRowClick ? 'button' : undefined}
			rowdata={rowData}
			rowindex={index}
			onClick={handleClick}
		>
			{columns.map(column => {
				const value = get(rowData, column.dataKey)
				if (column.render) {
					return (
						<td
							key={getCellKey(rowData[rowKey], column.id)}
							className={column.className}
							style={column.style}
						>
							{column.render(value, { column, rowData, index, tableState: state, tableSetState: setState })}
						</td>
					)
				}
				return (
					<td
						key={getCellKey(rowData[rowKey], column.id)}
						className={column.className}
						style={column.style}
					>
						{column.cell
							? cloneElement(column.cell, { value, rowData, column, index, tableState: state, tableSetState: setState })
							: createElement(({ value }) => <>{value}</>, { value })}
					</td>
				)
			})}
		</TheRow>
	)
}
export default Row
